// @ts-nocheck
/* eslint-disable */

import React from 'react';
import ViewEntity from '../../components/CRUD/ViewEntity';

const ViewFinancialAccount = () => {
  return (
    <ViewEntity
      pageTitle="FinancialAccountInfo"
      fetchApiUrl="/api/v1/web_portal/settlements/financial-accounts/:id"
      fetchApiMethod="GET"
      dataPath="data.data"
      fields={[
        {
          name: 'name',
          labelKey: 'Name',
          type: 'text',
        },
        {
          name: 'account_number',
          labelKey: 'AccountNumber',
          type: 'text',
        },
        {
          name: 'description',
          labelKey: 'Description',
          type: 'text',
        },
        {
          name: 'organisation_name',
          labelKey: 'Organisation',
          type: 'custom',
          render: (data, additionalData, intl) => {
            const orgData = additionalData?.organisationDetails;
            if (!orgData) return '-';
            const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
            return currentLanguageCode === 'en-us' 
              ? orgData.en_name 
              : orgData.ar_name;
          },
        },
        {
          name: 'account_type',
          labelKey: 'AccountType',
          type: 'custom',
          render: (data, additionalData, intl) => {
            const accountTypeData = additionalData?.accountTypeDetails;
            if (!accountTypeData) return '-';
            const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
            return currentLanguageCode === 'en-us' 
              ? accountTypeData.type_en 
              : accountTypeData.type_ar;
          },
        },
        {
          name: 'parent_account_name',
          labelKey: 'ParentAccount',
          type: 'custom',
          render: (data, additionalData, intl) => {
            const parentAccountData = additionalData?.parentAccountDetails;
            if (!parentAccountData) return '-';
            return parentAccountData?.name || '-';
          },
        },
        {
          name: 'balance',
          labelKey: 'Balance',
          type: 'text',
        },
        {
          name: 'created_at',
          labelKey: 'CreatedAt',
          type: 'date',
        },
        {
          name: 'updated_at',
          labelKey: 'UpdatedAt',
          type: 'date',
        },
      ]}
      additionalApis={[
        {
          name: 'organisationDetails',
          url: (mainData) => `/api/v1/organisations/${mainData.organisation_id}`,
          method: 'GET',
          dataPath: 'data.data',
        },
        {
          name: 'accountTypeDetails',
          url: (mainData) => `/api/v1/web_portal/settlements/financial-account-types/${mainData.financial_account_type_id}`,
          method: 'GET',
          dataPath: 'data.data',
        },
        {
          name: 'parentAccountDetails',
          url: (mainData) => mainData.parent_account_id ? `/api/v1/web_portal/settlements/financial-accounts/${mainData.parent_account_id}` : null,
          method: 'GET',
          dataPath: 'data.data',
        },
      ]}
      editUrl="/settlements/FinancialAccounts/:id/edit"
      deleteApiUrl="/api/v1/web_portal/settlements/financial-accounts/:id"
      deleteApiMethod="DELETE"
      backUrl="/settlements/FinancialAccounts/"
      backButtonLabel="BackToFinancialAccounts"
      buildTitle={(data, additionalData, intl) => {
        return data.name;
      }}
      buildDeleteConfirmMessage={(data, additionalData, currentLanguageCode, intl) => {
        return currentLanguageCode === 'en-us'
          ? `Are You Sure You Want To Delete ${data.name}?`
          : `هل أنت متأكد انك تريد حذف ${data.name}؟`;
      }}
      showEditButton={true}
      showDeleteButton={true}
      subsystemName="FinancialAccounts"
    />
  );
};

export default ViewFinancialAccount;
